export interface FeedbackRequired {
  rateYourWeek?: boolean;
  application?: boolean;
}

export enum ApplicationRating {
  Unknown = 0,
  Like = 1,
  Dislike = 2,
  NoRating = 3,
}
